module.exports = __webpack_public_path__ + "img/023.112bfe94.jpeg";